$(document).ready(function () {
    // FRONT STORE ITEM pricing
    // Init the suggested pricing datatable
    abcsetup.datatables.client_side.init($('#suggested_pricing_table'), {
        'dom': 'x',
        'iDisplayLength': -1,
        'order': [[1, 'asc']],
        'responsive': false,
        'colReorder': false,
    });
    $("#suggested_pricing_table tbody tr").on('click',function(event) {
        $("#suggested_pricing_table tbody tr").removeClass('row_selected');
        $(this).addClass('row_selected');
    });

    // Init the similar flc items pricing datatable
    abcsetup.datatables.client_side.init($('#similar_flc_pricing_table'), {
        'dom': 'x',
        'iDisplayLength': -1,
        'order': [[1, 'asc']],
        'responsive': false,
        'colReorder': false,
    });
    $("#similar_flc_pricing_table tbody tr").on('click',function(event) {
        $("#similar_flc_pricing_table tbody tr").removeClass('row_selected');
        $(this).addClass('row_selected');
    });

    // Init the similar supplier items pricing datatable
    abcsetup.datatables.client_side.init($('#similar_supplier_pricing_table'), {
        'dom': 'x',
        'iDisplayLength': -1,
        'order': [[3, 'asc']],
        'responsive': false,
        'colReorder': false,
    });
    $("#similar_supplier_pricing_table tbody tr").on('click',function(event) {
        $("#similar_supplier_pricing_table tbody tr").removeClass('row_selected');
        $(this).addClass('row_selected');
    });

    // Init the nielsen pricing datatable
    abcsetup.datatables.client_side.init($('#nielsen_pricing_table'), {
        'dom': 'x',
        'iDisplayLength': -1,
        'order': [[1, 'asc']],
        'responsive': false,
        'colReorder': false,
    });
    $("#nielsen_pricing_table tbody tr").on('click',function(event) {
        $("#nielsen_pricing_table tbody tr").removeClass('row_selected');
        $(this).addClass('row_selected');
    });

    $("a[value='copy_pricing']").click(function() {
        // Save the data to the browser's local Storage
        localStorage.setItem('zone1_price',$("input[name='zone1_retail_price']").val()*1.0);
        localStorage.setItem('zone2_price',$("input[name='zone2_retail_price']").val()*1.0);
        localStorage.setItem('zone3_price',$("input[name='zone3_retail_price']").val()*1.0);
        localStorage.setItem('zone4_price',$("input[name='zone4_retail_price']").val()*1.0);
        localStorage.setItem('zone5_price',$("input[name='zone5_retail_price']").val()*1.0);

        // Prepare the tooltip for the paste button
        var paste_tooltip = "Paste Pricing : <br>"+
            "Zone 1 : $"+localStorage.getItem("zone1_price")+"<br>"+
            "Zone 2 : $"+localStorage.getItem("zone2_price")+"<br>"+
            "Zone 3 : $"+localStorage.getItem("zone3_price")+"<br>"+
            "Zone 4 : $"+localStorage.getItem("zone4_price")+"<br>"+
            "Zone 5 : $"+localStorage.getItem("zone5_price");

        // Display the paste and clear buttons
        $("a[value='paste_pricing']").show().attr("title",'').attr('data-original-title',paste_tooltip);
        $("a[value='clear_clipboard']").show();
    });
    $("a[value='paste_pricing']").click(function() {
        // Populate the fields with the corresponding 'buffer' values
        $("input[name='zone1_retail_price']").val(localStorage.getItem('zone1_price'));
        $("input[name='zone2_retail_price']").val(localStorage.getItem('zone2_price'));
        $("input[name='zone3_retail_price']").val(localStorage.getItem('zone3_price'));
        $("input[name='zone4_retail_price']").val(localStorage.getItem('zone4_price'));
        $("input[name='zone5_retail_price']").val(localStorage.getItem('zone5_price'));

        // Calculate the new margins
        zone1_price = $("input[name='zone1_retail_price']").val()*1.0;
        margin1 = (zone1_price-retail_wac)/zone1_price*100;
        zone2_price = $("input[name='zone2_retail_price']").val()*1.0;
        margin2 = (zone2_price-retail_wac)/zone2_price*100;
        zone3_price = $("input[name='zone3_retail_price']").val()*1.0;
        margin3 = (zone3_price-retail_wac)/zone3_price*100;
        zone4_price = $("input[name='zone4_retail_price']").val()*1.0;
        margin4 = (zone4_price-retail_wac)/zone4_price*100;
        zone5_price = $("input[name='zone5_retail_price']").val()*1.0;
        margin5 = (zone5_price-retail_wac)/zone5_price*100;

        // Trigger the changes on the input fields to test the values and display the margins
        $("input[name='zone1_retail_price']").trigger('change',{revalidate:true});
        test_all_zone_prices();
    });

    $("a[value='clear_clipboard']").click(function() {
        $("a[value='paste_pricing']").hide();
        $("a[value='clear_clipboard']").hide();
        localStorage.removeItem('zone1_price');
        localStorage.removeItem('zone2_price');
        localStorage.removeItem('zone3_price');
        localStorage.removeItem('zone4_price');
        localStorage.removeItem('zone5_price');
    });

    if (localStorage.getItem("zone1_price") !== null){
        var paste_tooltip = "Paste Pricing : <br>"+
            "Zone 1 : $"+localStorage.getItem("zone1_price")+"<br>"+
            "Zone 2 : $"+localStorage.getItem("zone2_price")+"<br>"+
            "Zone 3 : $"+localStorage.getItem("zone3_price")+"<br>"+
            "Zone 4 : $"+localStorage.getItem("zone4_price")+"<br>"+
            "Zone 5 : $"+localStorage.getItem("zone5_price");
        $("a[value='paste_pricing']").show().attr("title",'').attr('data-original-title',paste_tooltip);
        $("a[value='clear_clipboard']").show();
    }

    $(document).on("click", "a[value='copy_row_pricing']", function() {
        localStorage.setItem('zone1_price',$(this).data("z1_price")*1.0);
        localStorage.setItem('zone2_price',$(this).data("z2_price")*1.0);
        localStorage.setItem('zone3_price',$(this).data("z3_price")*1.0);
        localStorage.setItem('zone4_price',$(this).data("z4_price")*1.0);
        localStorage.setItem('zone5_price',$(this).data("z5_price")*1.0);

        // Prepare the tooltip for the paste button
        var paste_tooltip = "Paste Pricing : <br>"+
            "Zone 1 : $"+localStorage.getItem("zone1_price")+"<br>"+
            "Zone 2 : $"+localStorage.getItem("zone2_price")+"<br>"+
            "Zone 3 : $"+localStorage.getItem("zone3_price")+"<br>"+
            "Zone 4 : $"+localStorage.getItem("zone4_price")+"<br>"+
            "Zone 5 : $"+localStorage.getItem("zone5_price");

        // Display the paste and clear buttons
        $("a[value='paste_pricing']").show().attr("title",'').attr('data-original-title',paste_tooltip);
        $("a[value='clear_clipboard']").show();
    });

    $(document).on("click", "a[value='copy_suggested']", function () {
        var z1_suggested = $('#z1_suggested').data('value');
        var z2_suggested = $('#z2_suggested').data('value');
        var z3_suggested = $('#z3_suggested').data('value');
        var z4_suggested = $('#z4_suggested').data('value');
        var z5_suggested = $('#z5_suggested').data('value');
        
        $('#zone1_retail_price').val(z1_suggested).trigger('change');
        $('#zone2_retail_price').val(z2_suggested).trigger('change');
        $('#zone3_retail_price').val(z3_suggested).trigger('change');
        $('#zone4_retail_price').val(z4_suggested).trigger('change');
        $('#zone5_retail_price').val(z5_suggested).trigger('change');

        $("input[name='zone1_retail_price']").trigger('change',{revalidate:true});
        $("input[name='zone2_retail_price']").trigger('change',{revalidate:true});
        $("input[name='zone3_retail_price']").trigger('change',{revalidate:true});
        $("input[name='zone4_retail_price']").trigger('change',{revalidate:true});
        $("input[name='zone5_retail_price']").trigger('change',{revalidate:true});
    });

    $(document).on("click", "a[value='copy_replacement']", function () {
        var z1_replacement = $('#z1_replacement').data('value');
        var z2_replacement = $('#z2_replacement').data('value');
        var z3_replacement = $('#z3_replacement').data('value');
        var z4_replacement = $('#z4_replacement').data('value');
        var z5_replacement = $('#z5_replacement').data('value');
        
        $('#zone1_retail_price').val(z1_replacement).trigger('change');
        $('#zone2_retail_price').val(z2_replacement).trigger('change');
        $('#zone3_retail_price').val(z3_replacement).trigger('change');
        $('#zone4_retail_price').val(z4_replacement).trigger('change');
        $('#zone5_retail_price').val(z5_replacement).trigger('change');
    });

    var wac_price = parseFloat(abcsetup.item.wac_price);
    var map_price = $("input[name='map_price']").val()*1.0;
    var zone1_price = $("input[name='zone1_retail_price']").val()*1.0;
    var margin1 = (zone1_price-retail_wac)/zone1_price*100;
    var zone2_price = $("input[name='zone2_retail_price']").val()*1.0;
    var margin2 = (zone2_price-retail_wac)/zone2_price*100;
    var zone3_price = $("input[name='zone3_retail_price']").val()*1.0;
    var margin3 = (zone3_price-retail_wac)/zone3_price*100;
    var zone4_price = $("input[name='zone4_retail_price']").val()*1.0;
    var margin4 = (zone4_price-retail_wac)/zone4_price*100;
    var zone5_price = $("input[name='zone5_retail_price']").val()*1.0;
    var margin5 = (zone5_price-retail_wac)/zone5_price*100;

    var retail_pack_qty = parseFloat(abcsetup.item.retail_pack_qty);
    var retail_wac = wac_price/retail_pack_qty;

    $("input[name='retail_pack_qty']").val(retail_pack_qty.toFixed(2));
    $("input[name='wac_price']").val(wac_price.toFixed(2));

    $("input[name='map_price']").change(function() {
        map_price = $("input[name='map_price']").val()*1.0;
        console_log('MAP: '+map_price);
        if (zone1_price<map_price){
            $("span[name='margin1']").addClass('warning');
            $("span[name='margin1']").attr('title','Zone 1 pricing is less than MAP');
        } else {
            if (margin1<26){
                $("span[name='margin1']").addClass('warning');
                $("span[name='margin1']").attr('title','Zone 1 margin is less than 26%');
            } else {
                $("span[name='margin1']").removeClass('warning');
                $("span[name='margin1']").attr('title','');
            }
        }
    }).trigger("change");

    $("input[name='zone1_retail_price']").on("change keyup", function({revalidate = false} = {}) {
        if (!revalidate) {
            zone1_price = $("input[name='zone1_retail_price']").val()*1.0;
            test_all_zone_prices();
        }
        $("input[name='zone2_retail_price']").trigger('change',{revalidate:true});
    }).trigger("change");


    $("input[name='zone2_retail_price']").on("change keyup",function({revalidate = false} = {}) {
        if (!revalidate) {
            zone2_price = $("input[name='zone2_retail_price']").val()*1.0;
            test_all_zone_prices();
        }
        $("input[name='zone3_retail_price']").trigger('change',{revalidate:true});
    }).trigger("change");

    $("input[name='zone3_retail_price']").on("change keyup",function({revalidate = false} = {}) {
        if (!revalidate) {
            zone3_price = $("input[name='zone3_retail_price']").val()*1.0;
            test_all_zone_prices();
        }
        $("input[name='zone4_retail_price']").trigger('change',{revalidate:true});
    }).trigger("change");

    $("input[name='zone4_retail_price']").on("change keyup",function({revalidate = false} = {}) {
        if (!revalidate) {
            zone4_price = $("input[name='zone4_retail_price']").val()*1.0;
            test_all_zone_prices();
        }
        $("input[name='zone5_retail_price']").trigger('change',{revalidate:true});
    }).trigger("change");

    $("input[name='zone5_retail_price']").on("change keyup",function({revalidate = false} = {}) {
        if (!revalidate) {
            zone5_price = $("input[name='zone5_retail_price']").val()*1.0;
            test_all_zone_prices();
        }
    }).trigger("change");

    function test_all_zone_prices() {
        //-Calculate and display margins
        //-if map is populated: WARN if Zone 1 is lower than MAP
        //-NO zone below WAC
        //-WARN if Zone 1 is less than 26%
        //-NOT ALLOWED : Zone 2 < Zone 1 , Zone 3 < Zone 2 , Zone 4 < Zone 3 , Zone 4 < Zone 5

        //-All retail prices must end in a 9
        //-Any price that ends in .09 should be rounded up to .19
        
        var nbePennyProfit = [
            $('#nbe_penny_profit_1').data('value'),
            $('#nbe_penny_profit_2').data('value'),
            $('#nbe_penny_profit_3').data('value'),
            $('#nbe_penny_profit_4').data('value'),
            $('#nbe_penny_profit_5').data('value')
        ];
        var gnpPrices = [
            $('#nbe-item-z1-price').data('value'),
            $('#nbe-item-z2-price').data('value'),
            $('#nbe-item-z3-price').data('value'),
            $('#nbe-item-z4-price').data('value'),
            $('#nbe-item-z5-price').data('value')
        ];
        var zonePrices = [
            parseFloat($('#zone1_retail_price').val()),
            parseFloat($('#zone2_retail_price').val()),
            parseFloat($('#zone3_retail_price').val()),
            parseFloat($('#zone4_retail_price').val()),
            parseFloat($('#zone5_retail_price').val())
        ];
    
        var margins = [];
        var pennyProfits = [];
        var gnpSavings = [];
    
        for (var i = 0; i < zonePrices.length; i++) {
            if (zonePrices[i] != '' && !isNaN(zonePrices[i])) {
                var roundedPrice = applyRoundingRules(zonePrices[i]);
                if (roundedPrice != zonePrices[i]) {
                    $("span[name='rounding_warning" + (i + 1) + "']").html("All prices should end with 9! Cannot end with .09").addClass('alert alert-danger  danger');
                    
                    $(document).ready(function() {
                        $(".btn-submit.manual-disabled").prop("disabled", true);
                    });
                    
                } else {
                    $("span[name='rounding_warning" + (i + 1) + "']").html("").removeClass('alert alert-danger danger');
                    $(".btn-submit.manual-disabled").prop("disabled", false);
                }
    
                margins[i] = (zonePrices[i] - retail_wac) / zonePrices[i] * 100;
                pennyProfits[i] = (zonePrices[i] - retail_wac);
                gnpSavings[i] = ((gnpPrices[i] - zonePrices[i]) / gnpPrices[i]) * 100;
    
                $("span[name='margin" + (i + 1) + "']").html("Margin: " + margins[i].toFixed(2) + "%");
                $("span[name='penny_profit" + (i + 1) + "']").html("Penny Profit: $" + pennyProfits[i].toFixed(2)).addClass('pr-2 pl-2');
                $("span[name='gnp_savings" + (i + 1) + "']").html("GNP Savings: " + gnpSavings[i].toFixed(1) + "%");

                // Check if the next zone price is less than the previous one
                const $warning = $("span[name='zone_warning" + (i + 1) + "']");
                if (i > 0 && zonePrices[i] < zonePrices[i - 1]) {
                    $warning
                        .html("Zone " + (i + 1) + " price cannot be less than Zone " + i + " price")
                        .addClass('alert alert-danger danger');
                    valid = false;
                } else {
                    // Clear any existing warning if validation passes
                    $warning.html('').removeClass('alert alert-danger danger');
                }
    
                if (zonePrices[i] >= retail_wac) {
                    if (i == 0 && zonePrices[i] < map_price) {
                        $("span[name='margin" + (i + 1) + "']").addClass('alert alert-warning warning');
                        $("span[name='margin" + (i + 1) + "']").attr('title', 'Zone ' + (i + 1) + ' pricing is less than MAP');
                    } else if (i == 0 && margins[i] < 26) {
                        $("span[name='margin" + (i + 1) + "']").addClass('alert alert-warning warning');
                        $("span[name='margin" + (i + 1) + "']").attr('title', 'Zone ' + (i + 1) + ' margin is less than 26%');
                    } else {
                        $("span[name='margin" + (i + 1) + "']").removeClass('alert alert-warning warning');
                        $("span[name='margin" + (i + 1) + "']").attr('title', '');
                    }
                } else {
                    $("span[name='margin" + (i + 1) + "']").html("").removeClass('alert alert-warning warning');
                }
    
                if (nbePennyProfit[i] > pennyProfits[i]) {
                    $("span[name='penny_profit" + (i + 1) + "']").addClass('alert alert-danger danger');
                    $("span[name='penny_profit" + (i + 1) + "']").attr('title', 'NBE Penny Profit is greater than GNP Penny Profit');
                } else {
                    $("span[name='penny_profit" + (i + 1) + "']").removeClass('alert alert-danger danger');
                    $("span[name='penny_profit" + (i + 1) + "']").attr('title', '').html("");
                }
    
                if (gnpSavings[i] < 25.00) {
                    $("span[name='gnp_savings" + (i + 1) + "']").addClass('alert alert-danger danger');
                    $("span[name='gnp_savings" + (i + 1) + "']").attr('title', 'Please adjust pricing so that GNP Savings is at least 25%');
                } else {
                    $("span[name='gnp_savings" + (i + 1) + "']").removeClass('alert alert-danger danger');
                    $("span[name='gnp_savings" + (i + 1) + "']").attr('title', '');
                }
            } else {
                $("span[name='margin" + (i + 1) + "']").html("").removeClass('alert alert-warning warning');
            }
        }
    }
    
    function applyRoundingRules(value) {
        value = value.toString();
        var lastDigit = value.slice(-1);
        var length = value.length;
        var secondToLastDigit = value.charAt(length - 2);
        var floorMin = '0';
        var floorMax = '3';
        var ceilMin = '4';
        var ceilMax = '9';
    
        if (lastDigit !== '9' && secondToLastDigit !== '0') {
            if (lastDigit >= floorMin && lastDigit <= floorMax) {
                value = parseFloat(value);
                var whole = Math.floor(value);
                var decimal = value - whole;
                var roundedDecimal = (Math.round(decimal * 10) / 10) - 0.01;
    
                value = whole + roundedDecimal;
            }
    
            if (lastDigit >= ceilMin && lastDigit <= ceilMax) {
                value = parseFloat(value);
                var whole = Math.floor(value);
                var decimal = value - whole;
                var roundedDecimal = (Math.round(decimal * 10) / 10) + 0.09;
    
                value = whole + roundedDecimal;
            }
        }
    
        if (secondToLastDigit === '0' || secondToLastDigit === '1') {
            value = parseFloat(value);
            value = Math.floor(value) + 0.19;
        }
    
        return value;
    }
});
